// Illustrated icons for the Help & session sheet. Artwork follows
// docs/design/game-icon-style-guide.md: 320px transparent canvas, subject
// ~81% of it to match the GM microphone. Decorative — the row title carries
// the meaning, so they are hidden from screen readers.
import React from 'react';
import help from '../../assets/session-help/help.webp';
import removePlayer from '../../assets/session-help/remove-player.webp';
import letBackIn from '../../assets/session-help/let-back-in.webp';
import supportChat from '../../assets/session-help/support-chat.webp';
import moveOn from '../../assets/session-help/move-on.webp';
import restartQuestion from '../../assets/session-help/restart-question.webp';
import resetSession from '../../assets/session-help/reset-session.webp';
import vote from '../../assets/session-help/vote.webp';

const SRC = {
  help,
  'remove-player': removePlayer,
  'let-back-in': letBackIn,
  'support-chat': supportChat,
  'move-on': moveOn,
  'restart-question': restartQuestion,
  'reset-session': resetSession,
  vote,
};

export default function SessionIcon({ name, className = 'h-8 w-8' }) {
  return (
    <img
      src={SRC[name]}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={`object-contain ${className}`}
    />
  );
}
